var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirewallLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.6 256.1",
    style: {
      enableBackground: "new 0 0 490.6 256.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_00000087388169424114247960000016502046897901914806_);}\n\t.st2{clip-path:url(#SVGID_00000175299121487656548940000014715065635526329773_);}\n\t.st3{clip-path:url(#SVGID_00000049221346968963620630000007615993242758654350_);fill:#2795E3;}\n\t.st4{clip-path:url(#SVGID_00000069386311210777041560000013995685947521374120_);}\n\t.st5{clip-path:url(#SVGID_00000042717504542189406690000007461363852876080022_);fill:#2795E3;}\n\t.st6{clip-path:url(#SVGID_00000039816146969598087470000002689661110532098958_);}\n\t.st7{clip-path:url(#SVGID_00000047050256120876413310000008346172446806096016_);fill:#2795E3;}\n\t.st8{clip-path:url(#SVGID_00000016042655286430615060000008387816546677346179_);}\n\t.st9{clip-path:url(#SVGID_00000000932581137190753750000014059802366114390687_);fill:#2795E3;}\n\t.st10{clip-path:url(#SVGID_00000119837134547393798420000008098060887793888917_);}\n\t.st11{clip-path:url(#SVGID_00000145025855726109213030000013101048695798272419_);fill:#2795E3;}\n\t.st12{clip-path:url(#SVGID_00000120526345358911750430000006914260025243895962_);}\n\t.st13{clip-path:url(#SVGID_00000119106190919038549310000012558309671205666229_);fill:#2795E3;}\n\t.st14{clip-path:url(#SVGID_00000157278639667518235650000013120991912844486063_);}\n\t.st15{clip-path:url(#SVGID_00000057135744181423691970000013608551362212957095_);fill:#2795E3;}\n\t.st16{clip-path:url(#SVGID_00000098937527841930342260000009610993700427723156_);}\n\t.st17{clip-path:url(#SVGID_00000087384244691955456830000007638669868580366256_);fill:#2795E3;}\n\t.st18{clip-path:url(#SVGID_00000019665633035011169140000004185189095923858564_);}\n\t.st19{clip-path:url(#SVGID_00000034812691228666771880000006463289972247372458_);fill:#2795E3;}\n\t.st20{clip-path:url(#SVGID_00000013879654460391870980000014820914876243258778_);}\n\t.st21{clip-path:url(#SVGID_00000161622854119288963690000011782636485647312271_);fill:#2795E3;}\n\t.st22{fill:#2795E3;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 183,
    y: 59.8,
    width: 120.6,
    height: 94.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060001323546977884260000012470686869591015839_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060001323546977884260000012470686869591015839_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000021829648511596148480000012569276822808101791_",
    d: "M185.6,78.7H218c1.5,0,2.7-1.1,2.7-2.5V62.3 c0-1.4-1.2-2.5-2.7-2.5h-32.4c-1.5,0-2.7,1.1-2.7,2.5v13.8C183,77.5,184.2,78.7,185.6,78.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108309635440216062740000012566478130789023932_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021829648511596148480000012569276822808101791_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000108309635440216062740000012566478130789023932_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119828323077605479790000000420784121094659491_",
    x: 145.3,
    y: 22.1,
    width: 196.1,
    height: 165.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121982672697255632820000015963013635718670720_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119828323077605479790000000420784121094659491_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 179.2,
    y: 56,
    style: {
      clipPath: "url(#SVGID_00000121982672697255632820000015963013635718670720_)",
      fill: "#2795E3"
    },
    width: 45.2,
    height: 26.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060001323546977884260000012470686869591015839_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000060009626382024085520000007306513824780392883_",
    d: "M231.9,78c1.7-2.2,4.4-3.5,7.2-3.5 c1.6,0,3.3,0.4,4.6,1.3c1.5,0.9,2.9,1.9,4.3,2.9h11.5c1.5,0,2.7-1.1,2.7-2.5V62.3c0-1.4-1.2-2.5-2.7-2.5h-32.4 c-1.5,0-2.7,1.1-2.7,2.5v13.8c0,1.4,1.2,2.5,2.7,2.5h4.3C231.6,78.4,231.7,78.1,231.9,78z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013180920097626029000000005553167675192803758_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060009626382024085520000007306513824780392883_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013180920097626029000000005553167675192803758_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005968338341685112190000008885381461301299120_",
    x: 145.3,
    y: 22.1,
    width: 196.1,
    height: 165.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151504776919365802980000002408537877840134807_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005968338341685112190000008885381461301299120_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 220.7,
    y: 56,
    style: {
      clipPath: "url(#SVGID_00000151504776919365802980000002408537877840134807_)",
      fill: "#2795E3"
    },
    width: 45.2,
    height: 26.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060001323546977884260000012470686869591015839_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000115515206616687911180000013330221012660748724_",
    d: "M303.6,62.3c0-1.4-1.2-2.5-2.7-2.5h-32.4 c-1.5,0-2.7,1.1-2.7,2.5v13.8c0,1.4,1.2,2.5,2.7,2.5h32.4c1.5,0,2.7-1.1,2.7-2.5V62.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058548377841884058130000009365488189944463495_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115515206616687911180000013330221012660748724_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000058548377841884058130000009365488189944463495_)"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116201345158724379820000016860326402247879085_",
    x: 145.3,
    y: 22.1,
    width: 196.1,
    height: 165.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153669090406272982400000000744660872398264228_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116201345158724379820000016860326402247879085_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 262.1,
    y: 56,
    style: {
      clipPath: "url(#SVGID_00000153669090406272982400000000744660872398264228_)",
      fill: "#2795E3"
    },
    width: 45.2,
    height: 26.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060001323546977884260000012470686869591015839_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000018234920608402100530000017187401391494248341_",
    d: "M185.6,105h9.9c1.4,0,2.6-1.1,2.6-2.5V88.7 c0-1.4-1.2-2.5-2.6-2.5h-9.9c-1.4,0-2.6,1.1-2.6,2.5v13.8C183,103.9,184.1,105,185.6,105z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064339565381413020550000003722651614679640498_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018234920608402100530000017187401391494248341_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000064339565381413020550000003722651614679640498_)"
    }
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000013150588892326206760000011317006725802493871_",
    x: 145.3,
    y: 22.1,
    width: 196.1,
    height: 165.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171711724482010045620000009704202576055853441_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013150588892326206760000011317006725802493871_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 179.2,
    y: 82.4,
    style: {
      clipPath: "url(#SVGID_00000171711724482010045620000009704202576055853441_)",
      fill: "#2795E3"
    },
    width: 22.6,
    height: 26.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060001323546977884260000012470686869591015839_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000053505758652484457860000011950992229120476095_",
    d: "M201.8,88.7v13.8c0,1.4,1.3,2.5,2.8,2.5h12.9 c2.1-2.6,4.5-5.2,6.6-7.4c3.4-3.6,8.3-9,7.7-10.8c0-0.2-0.1-0.4-0.1-0.6h-27.1C203.1,86.2,201.8,87.3,201.8,88.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006682103958570788520000011725809986446093748_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053505758652484457860000011950992229120476095_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006682103958570788520000011725809986446093748_)"
    }
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000051371608256795975210000007411344141929229492_",
    x: 145.3,
    y: 22.1,
    width: 196.1,
    height: 165.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030470292975325143670000002047774694487908027_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051371608256795975210000007411344141929229492_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 82.4,
    style: {
      clipPath: "url(#SVGID_00000030470292975325143670000002047774694487908027_)",
      fill: "#2795E3"
    },
    width: 38.2,
    height: 26.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060001323546977884260000012470686869591015839_)"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000125561164448975500540000013473279910933652366_",
    d: "M264,102.1c2.4,0,4.9,1,6.4,2.7 c0.1,0.1,0.1,0.1,0.3,0.2h11.5c1.4,0,2.6-1.2,2.6-2.6V88.7c0-1.4-1.2-2.6-2.6-2.6h-27.5c3.6,4.8,6.3,10.4,8.2,16.1 C263.2,102.1,263.6,102.1,264,102.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054257034409580881500000001553335027295746710_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125561164448975500540000013473279910933652366_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054257034409580881500000001553335027295746710_)"
    }
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000041992314469198004790000012013449978920663946_",
    x: 145.3,
    y: 22.1,
    width: 196.1,
    height: 165.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043457372837218040600000012888128866359573909_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041992314469198004790000012013449978920663946_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 250.8,
    y: 82.4,
    style: {
      clipPath: "url(#SVGID_00000043457372837218040600000012888128866359573909_)",
      fill: "#2795E3"
    },
    width: 37.7,
    height: 26.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060001323546977884260000012470686869591015839_)"
    }
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020395242629685562690000017322883737327906690_",
    d: "M301,86.2h-9.9c-1.4,0-2.6,1.1-2.6,2.5v13.8 c0,1.4,1.2,2.5,2.6,2.5h9.9c1.4,0,2.6-1.1,2.6-2.5V88.7C303.6,87.3,302.4,86.2,301,86.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026872539804051924200000006277382151515931058_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020395242629685562690000017322883737327906690_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026872539804051924200000006277382151515931058_)"
    }
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052803720445124020160000014919139106105394597_",
    x: 145.3,
    y: 22.1,
    width: 196.1,
    height: 165.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001629358615255490750000016241600322386881157_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052803720445124020160000014919139106105394597_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 284.8,
    y: 82.4,
    style: {
      clipPath: "url(#SVGID_00000001629358615255490750000016241600322386881157_)",
      fill: "#2795E3"
    },
    width: 22.6,
    height: 26.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060001323546977884260000012470686869591015839_)"
    }
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000147219272533185741240000009105705808604013734_",
    d: "M185.4,112.6c-1.3,0-2.5,1.1-2.5,2.5v13.8 c0,1.4,1.1,2.5,2.5,2.5h23.2v-1.7c0-6.6,1.8-12.3,4.5-17.2H185.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134248320953299480240000003943038163560605105_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147219272533185741240000009105705808604013734_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000134248320953299480240000003943038163560605105_)"
    }
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000044137226516311413930000013906546449288999841_",
    x: 145.3,
    y: 22.1,
    width: 196.1,
    height: 165.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164514392565382084900000008050099226549699462_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044137226516311413930000013906546449288999841_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 179.2,
    y: 108.8,
    style: {
      clipPath: "url(#SVGID_00000164514392565382084900000008050099226549699462_)",
      fill: "#2795E3"
    },
    width: 37.7,
    height: 26.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060001323546977884260000012470686869591015839_)"
    }
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000140716435443846243910000004526253551519600528_",
    d: "M300.2,112.6h-27.8c2.5,4.9,3.8,10.8,3.8,17.2v1.7 h23.8c1.4,0,2.5-1.1,2.5-2.5v-13.8C302.8,113.7,301.6,112.6,300.2,112.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099633307997709376390000018056076732363857548_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140716435443846243910000004526253551519600528_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000099633307997709376390000018056076732363857548_)"
    }
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000042698009530489727100000014956057538449836977_",
    x: 148.1,
    y: 22.1,
    width: 196.1,
    height: 165.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116930183846090540530000005915682972944727691_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042698009530489727100000014956057538449836977_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 268.7,
    y: 108.8,
    style: {
      clipPath: "url(#SVGID_00000116930183846090540530000005915682972944727691_)",
      fill: "#2795E3"
    },
    width: 37.8,
    height: 26.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060001323546977884260000012470686869591015839_)"
    }
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000098193456478050308670000016100825163237469837_",
    d: "M261.7,109.3c0.1,5.8-5.2,10.5-5.2,10.5 c0.7-11.4-5.7-30.6-16.9-37.3c-0.7-0.4-1.4,0.2-1.2,0.9c4.1,12.1-21.6,23.5-21.6,43.7c0,8.3,4,15.9,8.9,22.3 c1.4,1.9,4.5,0.6,4.3-1.7c-0.1-0.9-0.1-1.6-0.1-2.5c0-12,12.4-19,11.1-26.3c-0.1-0.6,0.7-1.1,1-0.6c5.3,4.5,8.4,15.6,8,22.4 c0,0,2.3-2.5,2.6-5.8c0-0.6,0.9-0.9,1.3-0.2c2.7,4,2.7,8.9,2.7,10.5c0,0.9,0,1.7-0.1,2.5c-0.2,2.4,2.7,3.6,4.3,1.7 c4.9-6.3,8.9-13.9,8.9-22.3c0-2.7,0-11.5-6.6-18.4C262.6,108.2,261.7,108.6,261.7,109.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107584233342173778410000009933552988314497675_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098193456478050308670000016100825163237469837_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107584233342173778410000009933552988314497675_)"
    }
  }, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000077319904932449499880000011828296849112763807_",
    x: 145.3,
    y: 22.1,
    width: 196.1,
    height: 165.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121241275952353398230000003701270456897340323_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077319904932449499880000011828296849112763807_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 213.1,
    y: 78.4,
    style: {
      clipPath: "url(#SVGID_00000121241275952353398230000003701270456897340323_)",
      fill: "#2795E3"
    },
    width: 60.3,
    height: 76.6
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M166.2,173.3h-16c-0.1,0-0.2,0.1-0.2,0.2v9.7c0,0.1,0.1,0.2,0.2,0.2h11c0.3,0,0.5,0.2,0.5,0.5v2.9 c0,0.3-0.2,0.5-0.5,0.5h-11c-0.1,0-0.2,0.1-0.2,0.2v13.4c0,0.3-0.2,0.5-0.5,0.5h-3.4c-0.3,0-0.5-0.2-0.5-0.5V170 c0-0.3,0.2-0.5,0.5-0.5h20.1c0.3,0,0.5,0.2,0.5,0.5v2.9C166.6,173.1,166.5,173.3,166.2,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M171.2,200.7V170c0-0.3,0.2-0.5,0.5-0.5h3.4c0.3,0,0.5,0.2,0.5,0.5v30.8c0,0.3-0.2,0.5-0.5,0.5h-3.4 C171.4,201.2,171.2,201,171.2,200.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M200.5,200.9l-6.3-13.5c0-0.1-0.1-0.1-0.2-0.1h-6.5c-0.1,0-0.2,0.1-0.2,0.2v13.3c0,0.3-0.2,0.5-0.5,0.5h-3.4 c-0.3,0-0.5-0.2-0.5-0.5V170c0-0.3,0.2-0.5,0.5-0.5h12.2c1.8,0,3.4,0.4,4.8,1.1c1.4,0.8,2.4,1.8,3.2,3.2c0.8,1.4,1.1,2.9,1.1,4.7 c0,2.1-0.5,3.9-1.7,5.4c-1.1,1.5-2.6,2.5-4.6,3c-0.1,0.1-0.2,0.1-0.1,0.2l6.6,13.6c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.3-0.4,0.3H201 C200.8,201.2,200.6,201.1,200.5,200.9z M187.3,173.5v10.1c0,0.1,0.1,0.2,0.2,0.2h7.6c1.6,0,2.9-0.5,3.8-1.4c1-0.9,1.4-2.2,1.4-3.8 c0-1.6-0.5-2.9-1.4-3.8c-1-1-2.2-1.4-3.8-1.4h-7.6C187.4,173.3,187.3,173.3,187.3,173.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M231.3,173.3h-16.1c-0.1,0-0.2,0.1-0.2,0.2v9.7c0,0.1,0.1,0.2,0.2,0.2h11c0.3,0,0.5,0.2,0.5,0.5v2.9 c0,0.3-0.2,0.5-0.5,0.5h-11c-0.1,0-0.2,0.1-0.2,0.2v10c0,0.1,0.1,0.2,0.2,0.2h16.1c0.3,0,0.5,0.2,0.5,0.5v2.8 c0,0.3-0.2,0.5-0.5,0.5h-20.1c-0.3,0-0.5-0.2-0.5-0.5V170c0-0.3,0.2-0.5,0.5-0.5h20.1c0.3,0,0.5,0.2,0.5,0.5v2.9 C231.7,173.1,231.6,173.3,231.3,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M243.7,200.8l-8.5-30.8l0-0.1c0-0.2,0.1-0.4,0.5-0.4h3.7c0.3,0,0.4,0.1,0.5,0.4l5.9,22.5 c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1-0.1l5.6-22.5c0.1-0.3,0.2-0.4,0.5-0.4h3.6c0.3,0,0.4,0.1,0.5,0.4l5.9,22.6 c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1-0.1l6-22.6c0.1-0.3,0.2-0.4,0.5-0.4h3.4c0.2,0,0.3,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.4 l-8.2,30.8c-0.1,0.3-0.2,0.4-0.5,0.4h-3.5c-0.3,0-0.4-0.1-0.5-0.4l-5.9-23.3c0-0.1-0.1-0.1-0.1-0.1s-0.1,0-0.1,0.1l-5.7,23.3 c0,0.3-0.2,0.4-0.5,0.4h-3.3C244,201.2,243.8,201.1,243.7,200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M296.2,200.8l-1.6-5.3c0-0.1-0.1-0.1-0.2-0.1h-12.7c-0.1,0-0.2,0-0.2,0.1l-1.6,5.3c-0.1,0.2-0.3,0.4-0.5,0.4 h-3.7c-0.3,0-0.5-0.2-0.4-0.5l9.9-30.8c0.1-0.2,0.3-0.4,0.5-0.4h4.5c0.3,0,0.5,0.1,0.5,0.4l10,30.8l0,0.2c0,0.2-0.1,0.3-0.4,0.3 h-3.7C296.4,201.2,296.3,201.1,296.2,200.8z M282.6,191.9c0,0,0.1,0.1,0.2,0.1h10.4c0.1,0,0.1,0,0.2-0.1c0,0,0.1-0.1,0-0.2 l-5.2-16.8c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1l-5.2,16.8C282.6,191.8,282.6,191.8,282.6,191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M306,200.7V170c0-0.3,0.2-0.5,0.5-0.5h3.4c0.3,0,0.5,0.2,0.5,0.5v27.3c0,0.1,0.1,0.2,0.2,0.2h15.6 c0.3,0,0.5,0.2,0.5,0.5v2.8c0,0.3-0.2,0.5-0.5,0.5h-19.7C306.1,201.2,306,201,306,200.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M331.8,200.7V170c0-0.3,0.2-0.5,0.5-0.5h3.4c0.3,0,0.5,0.2,0.5,0.5v27.3c0,0.1,0.1,0.2,0.2,0.2h15.6 c0.3,0,0.5,0.2,0.5,0.5v2.8c0,0.3-0.2,0.5-0.5,0.5h-19.7C331.9,201.2,331.8,201,331.8,200.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirewallLogo);
export default __webpack_public_path__ + "static/media/firewall-logo.ac7b57b4ec733f07f7a5ce60efa91bab.svg";
export { ForwardRef as ReactComponent };